var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3A3F41",
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.334 12.316l-3.47.445c-.12.02-.225-.084-.21-.21L1.1 9.08c.014-.072.05-.138.102-.19L8.85 1.24c.368-.366 1.037-.292 1.496.167l1.662 1.662c.46.455.534 1.125.166 1.492L4.527 12.21c-.053.054-.12.09-.193.104z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.385 5.355L8.06 2.03m1.995 4.654L6.73 3.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.364 12.126L1.29 9.05",
    strokeLinecap: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f70a8615eb98a126041ec49a90ddf572.svg";
export { ForwardRef as ReactComponent };